import React, { useState, useEffect, useRef } from 'react';
import { 
  FaChartLine, FaLightbulb, FaUsers, FaGlobe, 
  FaMoneyBillWave, FaTruck, FaHandHoldingUsd, 
  FaArrowRight, FaChevronLeft, FaChevronRight 
} from 'react-icons/fa';
import './Parceiros.css';

import parceirosCta from '../assets/images/parceiros-cta.jpg';
import parceiros1 from '../assets/images/Parceiros (1).jpg';
import parceiros3 from '../assets/images/Parceiros (3).jpg';

const Parceiros = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slideIntervalRef = useRef(null);
  
  const slides = [parceirosCta, parceiros1, parceiros3];
  const slideCount = slides.length;

  useEffect(() => {
    slideIntervalRef.current = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slideCount);
    }, 8000);

    return () => {
      if (slideIntervalRef.current) {
        clearInterval(slideIntervalRef.current);
        slideIntervalRef.current = null;
      }
    };
  }, [slideCount]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
    if (slideIntervalRef.current) {
      clearInterval(slideIntervalRef.current);
      slideIntervalRef.current = null;
    }
    slideIntervalRef.current = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slideCount);
    }, 8000);
  };

  const nextSlide = () => goToSlide((currentSlide + 1) % slideCount);
  const prevSlide = () => goToSlide((currentSlide - 1 + slideCount) % slideCount);

  return (
    <div className="parceiros-container">
      {/* ===== HERO COM CARROSSEL ===== */}
      <div className="parceiros-hero">
        <div className="parceiros-carousel">
          <div
            className="parceiros-carousel-track"
            style={{
              transform: `translateX(-${currentSlide * (100 / slideCount)}%)`,
              width: `${slideCount * 100}%`,
            }}
          >
            {slides.map((img, idx) => (
              <div 
                className="parceiros-carousel-slide" 
                key={idx}
                style={{ width: `${100 / slideCount}%` }}
              >
                <img src={img} alt={`Parceiros slide ${idx + 1}`} loading="lazy" />
              </div>
            ))}
          </div>

          <button className="parceiros-carousel-btn prev" onClick={prevSlide} aria-label="Anterior">
            <FaChevronLeft />
          </button>
          <button className="parceiros-carousel-btn next" onClick={nextSlide} aria-label="Seguinte">
            <FaChevronRight />
          </button>

          <div className="parceiros-carousel-dots">
            {slides.map((_, idx) => (
              <button
                key={idx}
                className={`parceiros-dot ${idx === currentSlide ? 'active' : ''}`}
                onClick={() => goToSlide(idx)}
                aria-label={`Ir para o slide ${idx + 1}`}
              />
            ))}
          </div>
        </div>

        <div className="hero-content">
          <h1>Faça Parte da Revolução do Transporte em Moçambique</h1>
          <p>Junte-se à Carga Fácil como Parceiro e cresça conosco neste Mercado Promissor</p>
        </div>
      </div>

      {/* ===== RESTANTE DO CONTEÚDO (BENEFÍCIOS, OPORTUNIDADES, CTA) ===== */}
      {/* Mantido intacto, conforme solicitado */}
      <div className="beneficios-section">
        <div className="section-header">
          <h2>Vantagens Exclusivas para Nossos Parceiros</h2>
          <p>Descubra como sua empresa pode se beneficiar desta colaboração estratégica</p>
        </div>
        <div className="beneficios-grid">
          <div className="beneficio-card">
            <div className="icon-container">
              <FaChartLine className="beneficio-icon" />
            </div>
            <h3>Retorno Financeiro</h3>
            <p>Participação em um modelo de negócios escalável com alto potencial de crescimento e retorno sobre investimento atrativo</p>
          </div>
          <div className="beneficio-card">
            <div className="icon-container">
              <FaLightbulb className="beneficio-icon" />
            </div>
            <h3>Tecnologia Inovadora</h3>
            <p>Acesso exclusivo à nossa plataforma digital de última geração com analytics em tempo real</p>
          </div>
          <div className="beneficio-card">
            <div className="icon-container">
              <FaUsers className="beneficio-icon" />
            </div>
            <h3>Base de Clientes</h3>
            <p>Exposição para milhares de usuários ativos e acesso a novos mercados através da nossa plataforma</p>
          </div>
          <div className="beneficio-card">
            <div className="icon-container">
              <FaGlobe className="beneficio-icon" />
            </div>
            <h3>Expansão Regional</h3>
            <p>Oportunidade de crescimento em todo território moçambicano com nossa rede logística integrada</p>
          </div>
        </div>
      </div>

      <div className="oportunidades-section">
        <div className="section-header">
          <h2>Modalidades de Parceria</h2>
          <p>Escolha a forma de colaboração que melhor se adapta ao seu negócio e objetivos</p>
        </div>
        <div className="oportunidades-grid">
          <div className="oportunidade-card investidores">
            <div className="card-header">
              <FaMoneyBillWave className="card-icon" />
              <h3>Investidores</h3>
            </div>
            <ul>
              <li>Taxas preferenciais nos serviços</li>
              <li>Relatórios trimestrais detalhados</li>
              <li>Acesso a oportunidades exclusivas</li>
            </ul>
            <button className="card-button">Investir Agora <FaArrowRight /></button>
          </div>
          
          <div className="oportunidade-card transportadoras">
            <div className="card-header">
              <FaTruck className="card-icon" />
              <h3>Transportadoras</h3>
            </div>
            <ul>
              <li>Aumento da capacidade operacional</li>
              <li>Redução de custos com ociosidade</li>
              <li>Treinamento especializado</li>
              <li>Gestão inteligente de frotas</li>
            </ul>
            <button className="card-button">Parceria Operacional <FaArrowRight /></button>
          </div>
          
          <div className="oportunidade-card financiadores">
            <div className="card-header">
              <FaHandHoldingUsd className="card-icon" />
              <h3>Financiadores</h3>
            </div>
            <ul>
              <li>Modelos de financiamento flexíveis</li>
              <li>Garantias reais e contratos seguros</li>
              <li>Portfólio diversificado</li>
            </ul>
            <button className="card-button">Oferecer Financiamento <FaArrowRight /></button>
          </div>
        </div>
      </div>

      <div className="cta-section">
        <div className="cta-content">
          <h2>Pronto para fazer parte desta jornada?</h2>
          <p>
            Nossa equipa de especialistas está pronta para discutir oportunidades personalizadas para o seu negócio
          </p>
          <div className="cta-buttons">
            <a href="mailto:contacto@cargafacil.co.mz" className="cta-button-primary">
              Fale Conosco <FaArrowRight />
            </a>
            <a href="tel:+258820985159" className="cta-button-secondary">
              Agendar Reunião <FaArrowRight />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Parceiros;